import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, MapPin } from "lucide-react";
import { api } from "../lib/apiClient";
import { Row } from "./Row";
import { ShortThumb } from "./ShortThumb";

const PHILLY_URL = "/channel/qtvtiktok?section=Philadelphia";

export const PhillySpotlight = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    api.get("/spotlight/philly").then((r) => setVideos(r.data)).catch((e) => console.error("Philly spotlight failed", e));
  }, []);

  if (!videos.length) return null;

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
      <Row
        testid="home-row-philly-spotlight"
        title={
          <span className="flex items-center gap-2.5">
            <MapPin className="w-6 h-6 text-[#FF2A2A]" strokeWidth={2.5} />
            Philly Spotlight
          </span>
        }
        action={
          <Link
            to={PHILLY_URL}
            data-testid="home-explore-philly-spotlight"
            className="flex items-center gap-1 text-xs md:text-sm text-zinc-400 hover:text-white transition-colors"
          >
            Explore <ArrowRight className="w-4 h-4" />
          </Link>
        }
      >
        {videos.map((v) => (
          <ShortThumb key={v.id} video={v} to={PHILLY_URL} />
        ))}
      </Row>
    </motion.div>
  );
};
